/* barra de herramientas */
export var HERRAMIENTAS_CARGAR = 'BARRA_HERRAMIENTAS_CARGAR';
export var cargarBarraHerramientas = function cargarBarraHerramientas(barraHerramientas) {
  return {
    type: HERRAMIENTAS_CARGAR,
    barraHerramientas: barraHerramientas
  };
};
export var HERRAMIENTA_SELECCIONAR = 'BARRA_HERRAMIENTAS_SELECCIONAR_HERRAMIENTA';
export var seleccionarHerramienta = function seleccionarHerramienta(herramientaId, grupo, valor) {
  return {
    type: HERRAMIENTA_SELECCIONAR,
    herramientaId: herramientaId,
    grupo: grupo,
    valor: valor
  };
};
export var HERRAMIENTAS_TOGGLE = 'BARRA_HERRAMIENTAS_TOGGLE';
export var toggleHerramientas = function toggleHerramientas() {
  return {
    type: HERRAMIENTAS_TOGGLE
  };
};